var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditCard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "edit_card",
    "data-name": "edit card",
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.999,
    height: 19.995,
    viewBox: "0 0 22.999 19.995",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_464",
    "data-name": "Path 464",
    d: "M319.935,596.711h17.007v-.02h2.126v-5.986a2.059,2.059,0,0,0-2.111-2H319.935a2.053,2.053,0,0,0-2.116,1.982v.021l-.011,12.013a2.06,2.06,0,0,0,2.112,2h9.041v-2h-9.026Zm0-6.006h17.007v2H319.935Z",
    transform: "translate(-317.808 -588.702)",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_465",
    "data-name": "Path 465",
    d: "M339.271,599.275l-.729-.728a1.022,1.022,0,0,0-1.448,0l-.729.728,2.177,2.177.729-.729A1.024,1.024,0,0,0,339.271,599.275Z",
    transform: "translate(-316.572 -588.049)",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_466",
    "data-name": "Path 466",
    d: "M330.2,605.445v2.176h2.176l5.441-5.441L335.637,600Z",
    transform: "translate(-316.572 -587.627)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditCard);
export default __webpack_public_path__ + "static/media/edit-card.5d25bb51.svg";
export { ForwardRef as ReactComponent };